<template>
	<div class="page newpage">
		<div class="_flex">
			<el-date-picker v-model="search.time" type="daterange" value-format="yyyy-MM-dd" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
            <el-cascader v-model="search.depart" clearable :options="departArr" :props="{value:'id',label:'name',checkStrictly:true,multiple: true}" style="width: 300px;margin-left: 10px;" size="small" @visible-change="getDepartmentLists" placeholder="选择部门 "></el-cascader>
            <div><el-button size="mini" @click="req()" style="margin-left: 10px;" v-loading="loading" icon="el-icon-refresh">筛选</el-button></div>
		</div>
		<div class="_flex_sb mt_20">
			<div style="flex: 1 0 0;">
				<div class="f_22">短信发送趋势</div>
				<div class="_flex_sb c9 mt_20">
					<div>
						<div>发送员工</div>
						<div class="f_40 c0">{{data.admin_count}}<span class="f_14 c9 ml_20">去重</span></div>
					</div>
					<div>
						<div>发送条数</div>
						<div class="f_40 c0">{{data.sms_count}}<span class="f_14 c9 ml_20">次</span></div>
					</div>
					<div >
						<div>日均发送</div>
						<div class="f_40 c0">{{data.avg_day}}<span class="f_14 c9 ml_20">次</span></div>
					</div>
					<div>
						<div>人均发送</div>
						<div class="f_40 c0">{{data.avg_person}}<span class="f_14 c9 ml_20">次</span></div>
					</div>
				</div>
				<div id="myChart" style="height:500px;"></div>
			</div>
			<div class="w_30 ml_20">
				<div class="f_22">跟进排名Top10</div>
				<div id="myChart1" style="width: 100%;min-height:590px;"></div>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import { smsLogCount, DepartmentLists } from "@/request/apis.js"
export default{
    data(){
        return {
			name:'',
            list : [{id:1,name:'通知公告'}],
			show : false,
			represShow : false,
			formData : {
				name : ''
			},

            loading: false,
            departArr: [],
            data: {},
            searchInit: {},
            search: {
                time: [],
                depart: [],
                is_first: '',
            },
            myChart: {},
            myChart1: {},
        }
    },
	mounted() {
        console.log('crmorder mounted', this.$route);
        this.searchInit = {...this.search};
        this.init();
    },
    activated() {
        console.log('crmorder activated', this.$route);
        this.search = {...this.searchInit};
        this.init();
    },
    watch: {
        '$route'(to) {
            this.init();
        }
    },
	methods:{
        init(){
            this.myChart = echarts.init(document.getElementById('myChart'));
            this.myChart1 = echarts.init(document.getElementById('myChart1'));
            this.search.is_first = String(this.$route.query.is_first || '');
            this.req();
        },
        async req(){
            this.loading = true;
            var res = await smsLogCount(this.search);
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.search.time = res.data.time;
            this.data = res.data;

			this.myChart.setOption(res.data.chart_option);
            this.myChart1.setOption(res.data.top_option);
        },
        async getDepartmentLists(){
            var res = await DepartmentLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.departArr = res.data;
        },
	}
}
</script>

<style scoped>
</style> 